module.exports = __webpack_public_path__ + "img/info4.e944c61f.png";